import { useCallback } from 'react';

export const userHasPermission = (user, permission, permissionsField = []) => {
  // // if(!user || !user[permissionsField] || !user[permissionsField].includes(permission)) return false;
  if (!user || !user.roles || !user.roles.some((r) => permission.includes(r)))
    return false;
  return true;
};

export const makeDelay = (callback, ms) => {
  let timerDelay = 0;
  clearTimeout(timerDelay);
  timerDelay = setTimeout(callback, ms || 0);
};

export const checkUserRole = (authenticatedUser, rolesToCheck, children) => {
  const hasRole = authenticatedUser?.roles?.some((role) =>
    rolesToCheck.includes(role)
  );

  return hasRole ? children : null;
};
export const useNavigation = (navigate) => {
  const navigateTo = useCallback((path) => {
    navigate(path);
  }, [navigate]);
  return navigateTo;
};